import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createBrand,
  getABrand,
  resetState,
  updateABrand,
} from "../features/brand/brandSlice";

let schema = yup.object().shape({
  title: yup.string().required("Brand Name is Required"),
});
const Addbrand = ({ editId, editMode, onSuccess }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getBrandId = editId || location.pathname.split("/")[3];
  const isInModal = location.state?.fromModal;
  const newBrand = useSelector((state) => state.brand);
  const {
    isSuccess,
    isError,
    isLoading,
    createdBrand,
    brandName,
    updatedBrand,
  } = newBrand;
  useEffect(() => {
    if (getBrandId !== undefined) {
      dispatch(getABrand(getBrandId));
    } else {
      dispatch(resetState());
    }
  }, [getBrandId]);

  useEffect(() => {
    if (isSuccess && createdBrand) {
      toast.success("Brand Added Successfullly!");
      // Reset state to prevent multiple calls
      dispatch(resetState());
      if (onSuccess) {
        onSuccess();
      }
      if (!isInModal) {
        navigate("/admin/catalog");
      }
    }
    if (isSuccess && updatedBrand) {
      toast.success("Brand Updated Successfullly!");
      // Reset state to prevent multiple calls
      dispatch(resetState());
      if (onSuccess) {
        onSuccess();
      }
      if (!isInModal) {
        navigate("/admin/catalog");
      }
    }

    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdBrand, updatedBrand, onSuccess, dispatch]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: brandName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getBrandId !== undefined) {
        const data = { id: getBrandId, brandData: values };
        dispatch(updateABrand(data));
        dispatch(resetState());
      } else {
        dispatch(createBrand(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {editMode || (getBrandId !== undefined) ? "Edit" : "Add"} Brand
      </h3>
      <div className="w-full">
        <form action="" onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="w-full">
            <CustomInput
              type="text"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
              label="Enter Brand"
              id="brand"
            />
          </div>
          <div className="error text-sm">
            {formik.touched.title && formik.errors.title}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5 w-full md:w-auto py-2 px-4"
            type="submit"
          >
            {editMode || (getBrandId !== undefined) ? "Edit" : "Add"} Brand
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addbrand;
